import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import Pagination from "../../partials/content/Pagination";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";
import httpServices from "../../../services/httpServices/httpServices";

export default function ListCategorySitePublisher() {
  const [categoriesSitePublisher, setCategoriesSitePublisher] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [categoryNameSearchFilter, setCategoryNameSearchFilter] = useState();

  useEffect(() => {
    getListCategorySitePublisher();
  }, [currentPage, categoryNameSearchFilter]);

  const getListCategorySitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categories = await sendRequestGetListCategorySitePublisher(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categories) {
      return;
    }
    setCountPage(categories.count_page);
    setCategoriesSitePublisher(categories.data);
  };

  const sendRequestGetListCategorySitePublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpServices.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/list-category-site-publishers?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (categoryNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&name=${categoryNameSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generatePagination = () => {
    return (
      <Pagination
        countPage={countPage}
        currentPage={currentPage}
        paginationItemOnClickHandler={paginationItemOnClickHandler}
      />
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generateListSitePublisher = () => {
    return (
      <>
        <div class="row border border-1 rounded py-2">
          <div class="col-12 col-md-4">
            <div>
              <label>جستجو در نام دسته صنفی</label>
            </div>
            <div>
              <input
                className="form-control"
                type="text"
                placeholder="نام دسته صنفی خود را وارد کنید."
                onKeyUp={(e) => setCategoryNameSearchFilter(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>نام</td>
              </tr>
            </thead>
            <tbody>
              {categoriesSitePublisher.map((category, index) => {
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{category.name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <TitleBar title="لیست دسته های صنفی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {categoriesSitePublisher.length == 0 &&
              categoryNameSearchFilter == null ? (
                <></>
              ) : (
                generateListSitePublisher()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
